export default class CapabilityManager {
    constructor(grade, capabilities) {
        this.grade = grade;
        this.capabilityMap = {};
        capabilities.forEach((c) => {
            this.capabilityMap[c.title] = c;
        });
    }

    getFileVaultRetentionPeriodMonth() {
        return this.capabilityMap['File Vault Retention Period Month'].max;
    }

    getFileVaultSingleFileMaxSize() {
        return this.capabilityMap['Max Single File Vault Size'].max;
    }

    getFileVaultMaxSize() {
        return this.capabilityMap['Max File Vault Size'].max;
    }

    getMaxTeamMemberCount() {
        return this.capabilityMap['Team Member Count'].max;
    }

    getMaxAlbumCount() {
        return this.capabilityMap['Max Album Count'].max;
    }

    getMaxPhotoCountPerAlbum() {
        return this.capabilityMap['Photo Count Per Album'].max;
    }

    getPhotoCompression() {
        return this.capabilityMap['Photo Compression'].max;
    }

    getPhotoMaxWidth() {
        return this.capabilityMap['Max Photo Width'].max;
    }

    getPhotoMaxHeight() {
        return this.capabilityMap['Max Photo Height'].max;
    }

    isEmailModuleAvailable() {
        return !!this.capabilityMap['Email Module'].enabled;
    }

    isContractModuleAvailable() {
        return !!this.capabilityMap['Contract Module'].enabled;
    }

    isGoogleCalendarModuleAvailable() {
        return !!this.capabilityMap['Google Calendar Module'].enabled;
    }

    isFBCustomerContactAvailable() {
        return !!this.capabilityMap['Facebook Module'].enabled;
    }

    canCustomReminderHour() {
        return !!this.capabilityMap['Custom Reminder Hour'].enabled;
    }

    allowsPrivateService() {
        return !!this.capabilityMap['Allow Private Service'].enabled;
    }

    canShowFBCustomerChat() {
        return !!this.capabilityMap['Facebook Customer Chat'].enabled;
    }

    canManageMemberPoints() {
        return !!this.capabilityMap['Member Points'].enabled;
    }

    canCustomCampaignLimitedMembership() {
        return !!this.capabilityMap['Custom Campaign Limited Membership'].enabled;
    }

    isLineModuleAvailable() {
        return !!this.capabilityMap['Line Module'].enabled;
    }

    getCouponAvailableCountPerYear() {
        return this.capabilityMap['Coupon Available Per Year'].max;
    }

    getPromocodeAvailableCountPerYear() {
        return this.capabilityMap['Promocode Available Per Year'].max;
    }
}
